import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import MasterListReportActions, { MasterListReportRedux, MasterListReportTypes } from '../Redux/MasterListReportRedux'
import { notificationFail } from '../Redux/NotificationActions'

const MasterListReportCRUDObservable = createCRUDObservable({
  mainRedux: MasterListReportRedux,
  reduxPath: 'masterlistreport',
})

const masterlistsEpic = (action$, store, { Api }) =>
  action$.ofType(MasterListReportTypes.MasterListReportRequest)
    .mergeMap(({ start_date, end_date }) => (
      Observable
        .fromPromise(Api.masterlistreport.getMasterListReportExcel(start_date, end_date)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              MasterListReportActions.MasterListReportError('Falló la descarga'),
            ]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)

          document.body.appendChild(link)
          link.click()
          return [
            MasterListReportActions.MasterListReportSuccess(data, fileName),
          ]
        })
    ))

const centersMasterListsEpic = (action$, store, { Api }) =>
  action$.ofType(MasterListReportTypes.CentersMasterListReportRequest)
    .mergeMap(({ start_date, end_date, centerId }) => (
      Observable
        .fromPromise(Api.masterlistreport.getCentersMasterListReportExcel(start_date, end_date, centerId)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              notificationFail('Falló la descarga'),
              MasterListReportActions.CentersMasterListReportError('Falló la descarga'),
            ]
          }
          const { data } = response
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            MasterListReportActions.CentersMasterListReportSuccess(data, fileName),
          ]
        })
    ))

export const MasterListReportObservers = Object.assign({}, MasterListReportCRUDObservable.observers, {})
export const masterlistreportEpic = combineEpics(
  MasterListReportCRUDObservable.epic,
  masterlistsEpic,
  centersMasterListsEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/MasterListReportObservable.js